import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ScreenClassProvider } from "react-grid-system";

import 'shared-portal-components-v2/dist/shared-portal-components-v2.css'
// eslint-disable-next-line import/order -- order is correct
import App from "@/App";
import '@/styles/index.css';
// import '@/styles/ResetCss.scss';

import { initializeGridConfig } from "@/config/gridConfig";
initializeGridConfig();

function initializeApp() {
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- root element guaranteed to exist in index.html
createRoot(document.getElementById("root")!).render(
  <StrictMode>
     <ScreenClassProvider>
    <App />
    </ScreenClassProvider>
  </StrictMode>,
);

}

initializeApp();
